import { OrganizationType } from '@openeducation/hr-rn-shared-types';

export enum Path {
  Root = '/',
  Login = '/login',
  NewPassword = '/new-password',
  ResetPassword = '/reset-password',
  ResetPasswordEmail = '/reset-password-email',
  ResetPasswordLink = '/reset-password-link',
  Choice = '/choice',
  ExternalPortal = '/external-portal',
}

export enum OEPath {
  Home = '/oe-home',
  Licenses = '/oe-licenses',
  Student = '/oe-student',
  Admin = '/oe-admin',
}

export enum OMPath {
  Home = '/om-home',
  Licenses = '/om-licenses',
  Student = '/om-student',
  Admin = '/om-admin',
}

export type PathType = Path & OEPath & OMPath;

// Declare a route once; scope, portal and home page derive from it.
type PurchaserScopeKind =
  // The user can select several accounts.
  | 'multiple'
  // The route belongs to one account, taken from its URL.
  | 'single'
  // The route calls endpoints that accept the active account only.
  | 'active';

type RouteConfig = {
  organization: OrganizationType;
  scope: PurchaserScopeKind;
  homePath: OEPath | OMPath;
};

const OE = OrganizationType.OPEN_ENGLISH;
const OM = OrganizationType.OPEN_MUNDO;

export const ROUTE_CONFIG: Readonly<Record<string, RouteConfig>> = {
  [OEPath.Home]: { organization: OE, scope: 'multiple', homePath: OEPath.Home },
  [OEPath.Licenses]: { organization: OE, scope: 'multiple', homePath: OEPath.Home },
  [OEPath.Student]: { organization: OE, scope: 'single', homePath: OEPath.Home },
  [OEPath.Admin]: { organization: OE, scope: 'active', homePath: OEPath.Home },
  [OMPath.Home]: { organization: OM, scope: 'multiple', homePath: OMPath.Home },
  [OMPath.Licenses]: { organization: OM, scope: 'multiple', homePath: OMPath.Home },
  [OMPath.Student]: { organization: OM, scope: 'single', homePath: OMPath.Home },
  [OMPath.Admin]: { organization: OM, scope: 'active', homePath: OMPath.Home },
};

const pathsWithScope = (scope: PurchaserScopeKind): string[] =>
  Object.keys(ROUTE_CONFIG).filter((path) => ROUTE_CONFIG[path].scope === scope);

export const MULTIPLE_PURCHASER_PATHS: string[] = pathsWithScope('multiple');

export const SINGLE_PURCHASER_PATHS: string[] = pathsWithScope('single');

// The route owns the organization. A derived value changes with the route, where an effect lags it by a render.
export const getOrganizationByPath = (pathname: string): OrganizationType | null =>
  ROUTE_CONFIG[pathname]?.organization ?? null;

export const getHomePathByPath = (pathname: string): string | null =>
  ROUTE_CONFIG[pathname]?.homePath ?? null;

export const pathPrefixByOrganization = {
  [OE]: 'oe-',
  [OM]: 'om-',
};
